/* eslint-disable no-undef */
import React from 'react';
import './SideSteps.sass';

const SideSteps = () => (
  <div className="box-shadow">
    <div className="side-steps">
      <div className="sidebar">
        <h3 className="sidebar-header">{I18n.t('sidebar.3_steps.title')}</h3>
        <ul className="numbered-list__orange">
          <li>{I18n.t('sidebar.3_steps.search_by_city')}</li>
          <li>{I18n.t('sidebar.3_steps.search_offices')}</li>
          <li>{I18n.t('sidebar.3_steps.request_information')}</li>
        </ul>
      </div>
    </div>
  </div>
);

export default SideSteps;
